import {KTCard} from '../../../_metronic/helpers'
import {useGetPurchaserByBrandReport} from '../hooks/useGetPurchaserByBrandReport'
import {PurchaserByBrandReportContext} from '../context'
import PurchaserByBrandReportsHeader from '../sections/header/PurchaserByBrandReportsHeader'
import PurchaserByBrandReportTable from '../sections/table/PurchaserByBrandReportTable'
import useGetEntityPerformanceChartData from '../hooks/useGetEntityPerformanceChartData'
import useGetProfitTrend from '../hooks/useGetProfitTrend'

function PurchaserByBrandReport() {
  const {
    reportData: purchaserReportData,
    isLoading: isPurchaserReportLoading,
    filters,
    onSortingChange,
    handlePurchaserReportDateChange,
  } = useGetPurchaserByBrandReport()

  const {
    entityPerformanceChartData,
    isLoading: isEntityPerformanceChartDataLoading,
    onEntityPerformanceChartIdChange,
    onEntityPerformanceChartViewChange,
    onEntityPerformanceChartDateRangeChange,
    entityPerformanceChartFilters,
  } = useGetEntityPerformanceChartData('purchaser_by_brand')

  const {
    profitTrendChartData,
    kpiData: profitTrendKpiData,
    weeklyBreakdownData: profitTrendWeeklyBreakdownData,
    isLoading: isProfitTrendDataLoading,
    onProfitTrendIdChange,
  } = useGetProfitTrend('purchaser_by_brand')

  const contextValue = {
    purchaserReportData,
    isPurchaserReportLoading,
    filters,
    onSortingChange,
    handlePurchaserReportDateChange,

    entityPerformanceChartData,
    isEntityPerformanceChartDataLoading,
    onEntityPerformanceChartIdChange,
    onEntityPerformanceChartViewChange,
    onEntityPerformanceChartDateRangeChange,
    entityPerformanceChartFilters,

    // Profit Trend Modal Data
    profitTrendChartData,
    profitTrendKpiData,
    profitTrendWeeklyBreakdownData,
    isProfitTrendDataLoading,
    onProfitTrendIdChange,
  }

  return (
    <KTCard>
      <PurchaserByBrandReportContext.Provider value={contextValue}>
        <PurchaserByBrandReportsHeader />
        <PurchaserByBrandReportTable />
      </PurchaserByBrandReportContext.Provider>
    </KTCard>
  )
}

export default PurchaserByBrandReport
